<template>
  <div class="page-legislacao-municipal">
    <div class="centro">
      <div class="titulo-pagina">
        <div class="triangulo-play"></div>
        <h1><span>{{ enteFederativoNome }}</span></h1>
      </div>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />


    </div>
    <div class="pesquise">
      <div class="centro">
        <form @submit="buscar">
          <h2>PESQUISE AQUI</h2>
          <div class="row5">
            <div class="item">
              <label>Tipo</label>
              <div v-if="isMobile" class="mobile-multiselect-trigger" @click="abrirTipoMobileDropdown">
                <span v-if="tiposSelecionados.length === 0">Escolha opções...</span>
                <span v-else-if="tiposSelecionados.length === 1" class="tipo-nome-unico">{{ tiposSelecionados[0].nome }}</span>
                <span v-else>{{ tiposSelecionados.length }} selecionados</span>
              </div>
              <multiselect
                v-else
                v-model="tiposSelecionados"
                :options="tiposObjetos" 
                :multiple="true"
                :taggable="true"
                :searchable="true"
                :show-labels="false"
                placeholder="Escolha opções..."
                label="nome"
                track-by="id"
                class="multiselect-font font-black"
              />
            </div>
            <div class="item">
              <label>Ano</label>
              <input type="number" v-model="filtro.ano" />
            </div>
            <div class="item">
              <label>Nome do(a) Servidor(a)</label>
              <input type="text" v-model="filtro.nome" />
            </div>

            <div class="item">
              <label>Número do Ato</label>
              <input type="text" v-model="filtro.numero" />
            </div>

            <div class="item">
              <label>Assunto</label>
              <input type="text" v-model="filtro.assunto" />
            </div>
          </div>

          <div class="row2">
            <div class="grupo">
              <p>Data do Ato</p>
              <div class="data">
                <div class="item">
                  <label>De</label>
                  <date-picker
                    v-model="filtro.periodo_inicial_ato"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
                <div class="item">
                  <label>Até</label>
                  <date-picker
                    v-model="filtro.periodo_final_ato"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="grupo">
              <p>Data do Diário</p>
              <div class="data">
                <div class="item">
                  <label>De</label>
                  <date-picker
                    v-model="filtro.periodo_inicial_diario"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
                <div class="item">
                  <label>Até</label>
                  <date-picker
                    v-model="filtro.periodo_final_diario"
                    :formatter="datepickerFormatter"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="botoes">
            <button type="button" @click="limparFiltro">Limpar</button>
            <button type="submit">Buscar</button>
          </div>
        </form>
        <!-- <div class="seta">
          <img
            src="../../assets/images/triangulo-form.png"
            class="triangulo t-branco"
            alt=" "
          />
          <img
            src="../../assets/images/triangulo-form-black.png"
            class="triangulo t-preto"
            alt=" "
          />
        </div> -->
      </div>
    </div>
    <div class="centro campo-resultados" id="resultados">
      <div class="nav-resultados">
        <div class="first-flex">
          <h2>RESULTADOS DA PESQUISA</h2>
          <div
            class="dados-abertos"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <span>Dados Abertos:</span>
              <a @click="abrirDadosAbertos('json')">JSON</a>
              <a @click="abrirDadosAbertos('csv')">CSV</a>
            </p>
          </div>
        </div>
        <div class="second-flex">
          <ParametrosBusca
            :funcaoBuscaAvancada="buscar"
            :funcaoRemoveItemFiltro="removerItemFiltro"
            :tiposAto="tiposArrays"
            :filtro="filtro"
            contexto="ato_administrativo"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          />
          <div
            class="ordenacao"
            v-show="
              !carregando &&
              !erro &&
              !carregandoFiltros &&
              !erroFiltros &&
              termo
            "
          >
            <label for="ordenarPor">Ordenar por: </label>
            <select
              id="ordenarPor"
              v-model="ordenarPor"
              @change="atualizarOrdenacao"
            >
              <option value="data">Data</option>
              <option value="relevancia">Relevância</option>
            </select>
          </div>
        </div>
        <div class="third-flex">
          <div
            class="nresultados"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <strong>{{ totalResultadosTexto }}</strong>
              {{ totalResultadosTexto === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
            </p>
          </div>
          <div class="npagina" v-show="!carregando && !carregandoFiltros">
            <label>Resultados por Página</label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <TabelaResultadosAtoAdmin
          :atos="atos"
          :ente-federativo="enteFederativo"
          v-if="!carregando && !erro && !carregandoFiltros && !erroFiltros"
        ></TabelaResultadosAtoAdmin>

        <Loading v-if="carregando || carregandoFiltros" size="medium"></Loading>
        <ErroResultados
          v-if="(!carregando || !carregandoFiltros) && (erro || erroFiltros)"
        ></ErroResultados>

        <paginate
          v-if="!erro && !carregando"
          v-model="pagina"
          :page-count="pageCount"
          :click-handler="mudouPagina"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'className'"
          active-class="active-page"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from "vuejs-paginate";
  import { format, parseISO } from "date-fns";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import "vue2-datepicker/locale/pt-br";

  import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
  import TabelaResultadosAtoAdmin from "@/components/pesquisa_index_ato_administrativo/TabelaResultadosAtoAdmin";
  import { datepickerFormatter } from "@/helpers/datepickerFormatter";
  import Loading from "@/components/Loading";
  import ErroResultados from "@/components/ErroResultados";
  import tryParseInt from "@/helpers/tryParseInt";

  import ParametrosBusca from "@/components/ParametrosBusca";
  import { mixinAtoAdministrativo } from "@/mixins/mixinAtoAdministrativo";
  import metaDados from "@/helpers/metaDados";
  import Multiselect from "vue-multiselect";

  import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";


  export default {
    name: "AtosAdministrativosPorEnteFederativo",
    metaInfo() {
      return {
        title: "Pesquisa de Índice de Ato Administrativo",
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
          {
            vmid: "description",
            name: "description",
            property: "description",
            content:
              "Pesquisa de Índice de Atos Administrativos - Decretos e Portarias de nomeação",
          },
          {
            vmid: "og:description",
            property: "og:description",
            content:
              "Pesquisa de Índice de Atos Administrativos - Decretos e Portarias de nomeação",
          },
          {
            vmid: "og:title",
            property: "og:title",
            content:
              "Pesquisa de Índice de Ato Administrativo - Casa Civil do Estado de Goiás",
          },
          {
            vmid: "og:type",
            property: "og:type",
            content: "article",
          },
          {
            vmid: "twitter:description",
            name: "twitter:description",
            property: "twitter:description",
            content:
              "Pesquisa de Índice de Atos Administrativos - Decretos e Portarias de nomeação",
          },
          {
            vmid: "twitter:title",
            name: "twitter:title",
            property: "twitter:title",
            content:
              "Pesquisa de Índice de Ato Administrativo - Casa Civil do Estado de Goiás",
          },
          ...metaDados(this.$route),
        ],
      };
    },
    mixins: [mixinAtoAdministrativo],
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
    data() {
      return {
        enteFederativoNome: null,
        atos: [],
        carregando: true,
        erro: false,
        totalResultados: null,
        totalResultadosTexto: null,
        pagina: 1,
        qtd_por_pagina: 10,
        filtro: {
          tipo_ato: [],
          numero: null,
          nome: null,
          periodo_inicial_diario: null,
          periodo_final_diario: null,
          periodo_inicial_ato: null,
          periodo_final_ato: null,
          assunto: null,
          ano: null,
        },

        carregandoValoresFiltro: true,
        erroCarregandoValoresFiltro: false,
        datepickerFormatter,
        tiposSelecionadosMobile: [],
        showTipoMobileDropdown: false,
        tiposSelecionados: [],
        isMobile: window.innerWidth < 600,
        termo: null,
        tiposObjetos: [],
        tiposArrays: [],
        carregandoFiltros: true,
        erroCarregandoFiltros: false,
        erroFiltros: false,
        ordenarPor: '',
      };
    },
    components: {
      TabelaResultadosAtoAdmin,
      ParametrosBusca,
      Paginate,
      DatePicker,
      Loading,
      ErroResultados,
      Multiselect,
      BuscaSimplesCards,
    },
    created() {
      this.legislacaoApi = new LegislacaoMunicipalApi();
      this.obterEnteFederativo().then(() => {
        this.carregarQtdPorPagina();
        this.carregarValoresFiltro();
        this.carregarAtos();
      });
    },
    watch: {
      '$route.query': {
        handler() {
          if (this.enteFederativo) {
            this.carregarAtos();
          }
        },
      },
    },
    mounted() {
      window.addEventListener('resize', this.checkMobile);

      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo("#resultados", 700, {
              offset: -100,
              cancelable: false,
              onDone: () => this.focusResultados(),
            });
          }, 500);
        });
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
      async obterEnteFederativo() {
        try {
          const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
          this.enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);
          if (!this.enteFederativo) {
            this.erro = true;
            console.error("Ente Federativo não encontrado para o slug: ", this.slug);
          }
        } catch (err) {
          console.error("Erro ao obter Ente Federativo: ", err);
          this.erro = true;
        }
      },
      mudouQtdPagina: function (event) {
        const novaQtdPagina = parseInt(event.target.value);
        if (novaQtdPagina < this.qtd_por_pagina) {
          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(this.pagina);
        } else {
          let novaPagina = Math.ceil(
            (this.qtd_por_pagina * this.pagina) / novaQtdPagina
          );

          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(novaPagina);
        }
      },
      getParam: function (name) {
        if (this.$route && this.$route.query) {
          return this.$route.query[name];
        }
        return null;
      },

      buscar: function (event) {
        event.preventDefault();

        if (this.tiposSelecionados && this.tiposSelecionados.length > 0) {
          this.filtro.tipo_ato = this.tiposSelecionados.map(
            (tipo) => tipo.id
          );
        }

        this.$router.push({
          name: "AtosAdministrativosPorEnteFederativo",
          params: { slug: this.slug },
          query: {
            ...this.filtro,
            ...this.convertePeriodosDatasParaString(),
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
            busca_avancada: 1,
          },
        });

        this.$scrollTo("#resultados", 700, {
          offset: -100,
          cancelable: false,
        });
      },
      mudouPagina: function (page) {
        this.pagina = page;

        const filtro = {
          tipo_ato: this.getParam("tipo_ato"),
          numero: this.getParam("numero"),
          nome: this.getParam("nome"),
          periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
          periodo_final_diario: this.getParam("periodo_final_diario"),
          periodo_inicial_ato: this.getParam("periodo_inicial_ato"),
          periodo_final_ato: this.getParam("periodo_final_ato"),
          assunto: this.getParam("assunto"),
          ano: this.getParam("ano"),
        };

        this.$router.push({
          name: "AtosAdministrativosPorEnteFederativo",
          query: {
            ...filtro,
            pagina: this.pagina,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
        this.$scrollTo("#resultados", 0, {
          offset: -100,
          cancelable: false,
        });
      },
      carregarValoresFiltro: async function () {
        try {
          if (
            !this.carregando &&
            !this.erro &&
            this.tiposObjetos &&
            this.tiposObjetos.length > 0
          ) {
            return;
          }

          this.carregandoFiltros = true;
          this.erroFiltros = false;

          const tiposApi = await this.legislacaoApi.getTiposAtosAdministrativos(this.enteFederativo.id);
          this.tiposObjetos = tiposApi.map(tipo => ({ id: tipo.id, nome: tipo.nome }));
          this.tiposArrays = tiposApi.map(tipo => [tipo.nome, tipo.id]);

          if (this.getParam("tipo_ato")) {
            const tipoAtoParam = this.getParam("tipo_ato");
            const filtros = Array.isArray(tipoAtoParam)
              ? tipoAtoParam.map(id => parseInt(id))
              : [parseInt(tipoAtoParam)];

            this.tiposSelecionados = this.tiposObjetos.filter((tipo) =>
              filtros.includes(tipo.id)
            );
          } else {
            this.tiposSelecionados = [];
          }

          this.carregandoFiltros = false;
        } catch (err) {
          console.log("carregarValoresFiltro", err);
          this.carregandoFiltros = false;
          this.erroFiltros = true;
          this.tiposObjetos = [];
        }
      },
      carregarAtos: async function () {
        try {
          this.carregando = true;
          this.erro = false;

          this.qtd_por_pagina =
            this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

          this.armazenarQtdPorPagina();

          const pagina = this.getParam("pagina") || 1;
          this.pagina = parseInt(pagina);

          this.filtro = {
            numero: this.getParam("numero"),
            tipo_ato: this.getParam("tipo_ato"),
            nome: this.getParam("nome"),
            ano: this.getParam("ano"),
            assunto: this.getParam("assunto"),
            ...this.convertPeriodosStringParaDatas(),
          };

          if (this.legislacaoApi.cancelTokens.getAtosAdministrativosByEnteFederativo) {
            this.legislacaoApi.cancelTokens.getAtosAdministrativosByEnteFederativo.cancel();
          }

          let params = {
            ...this.filtro,
            periodo_inicial_ato: this.getParam(
              "periodo_inicial_ato"
            ),
            periodo_final_ato: this.getParam("periodo_final_ato"),
            periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
            periodo_final_diario: this.getParam("periodo_final_diario"),
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          };

          const data = await this.legislacaoApi.getAtosAdministrativosByEnteFederativo(
            this.enteFederativo.id,
            params
          );

          this.enteFederativoNome = data.ente_federativo.nome;
          this.atos = data.resultados;
          this.totalResultados = data.total_resultados;
          this.totalResultadosTexto = data.total_resultados.toLocaleString("pt-BR");
          this.carregando = false;
        } catch (err) {
          if (this.legislacaoApi.isCancel(err)) {
            return;
          }
          console.log("carregarAtos", err);
          this.carregando = false;
          this.erro = true;
        }
      },
      limparFiltro: function () {
        this.filtro = {
          tipo_ato: [],
          numero: null,
          nome: null,
          periodo_inicial_diario: null,
          periodo_final_diario: null,
          periodo_inicial_ato: null,
          periodo_final_ato: null,
          assunto: null,
          ano: null,
        };
        this.tiposSelecionados = [];
        this.tiposSelecionadosMobile = [];
      },
      convertePeriodosDatasParaString: function () {
        return {
          periodo_inicial_ato: this.filtro.periodo_inicial_ato
            ? format(this.filtro.periodo_inicial_ato, "yyyy-MM-dd")
            : null,
          periodo_final_ato: this.filtro.periodo_final_ato
            ? format(this.filtro.periodo_final_ato, "yyyy-MM-dd")
            : null,
          periodo_inicial_diario: this.filtro.periodo_inicial_diario
            ? format(this.filtro.periodo_inicial_diario, "yyyy-MM-dd")
            : null,
          periodo_final_diario: this.filtro.periodo_final_diario
            ? format(this.filtro.periodo_final_diario, "yyyy-MM-dd")
            : null,
        };
      },
      convertPeriodosStringParaDatas: function () {
        const periodo_inicial_ato = this.getParam(
          "periodo_inicial_ato"
        );
        const periodo_final_ato = this.getParam(
          "periodo_final_ato"
        );
        const periodo_inicial_diario = this.getParam("periodo_inicial_diario");
        const periodo_final_diario = this.getParam("periodo_final_diario");

        return {
          periodo_inicial_ato: periodo_inicial_ato
            ? parseISO(periodo_inicial_ato)
            : null,
          periodo_final_ato: periodo_final_ato
            ? parseISO(periodo_final_ato)
            : null,
          periodo_inicial_diario: periodo_inicial_diario
            ? parseISO(periodo_inicial_diario)
            : null,
          periodo_final_diario: periodo_final_diario
            ? parseISO(periodo_final_diario)
            : null,
        };
      },

      armazenarQtdPorPagina() {
        localStorage.setItem("qtd_por_pagina_atos_administrativos", this.qtd_por_pagina);
      },
      carregarQtdPorPagina() {
        const qtd = localStorage.getItem("qtd_por_pagina_atos_administrativos");
        if (qtd) {
          this.qtd_por_pagina = tryParseInt(qtd);
        }
      },
      checkMobile() {
        this.isMobile = window.innerWidth < 600;
      },
      abrirTipoMobileDropdown() {
        this.tiposSelecionadosMobile = [...this.tiposSelecionados];
        this.showTipoMobileDropdown = true;
      },
      closeTipoMobileDropdown() {
        this.showTipoMobileDropdown = false;
        this.tiposSelecionadosMobile = [...this.tiposSelecionados];
      },
      toggleTipoSelecionado(option) {
        const idx = this.tiposSelecionadosMobile.findIndex(sel => sel.id === option.id);
        if (idx === -1) {
          this.tiposSelecionadosMobile.push(option);
        } else {
          this.tiposSelecionadosMobile.splice(idx, 1);
        }
      },
      aplicarTipoSelecionados() {
        this.tiposSelecionados = [...this.tiposSelecionadosMobile];
        this.showTipoMobileDropdown = false;
      },
      removerItemFiltro({ key, id }) {
        if (key === 'tipo_ato' && id !== undefined) {
          let tipoAtoArray = Array.isArray(this.filtro.tipo_ato)
            ? this.filtro.tipo_ato
            : (typeof this.filtro.tipo_ato === 'string' && this.filtro.tipo_ato.includes(','))
              ? this.filtro.tipo_ato.split(',')
              : [this.filtro.tipo_ato];

          tipoAtoArray = tipoAtoArray.filter(tipoId => tipoId.toString() !== id.toString());

          this.filtro.tipo_ato = tipoAtoArray;

          this.tiposSelecionados = this.tiposSelecionados.filter(
            tipo => tipo.id.toString() !== id.toString()
          );
        } else if (key === 'ano') {
          this.filtro.ano = null;
        } else if (key === 'nome') {
          this.filtro.nome = null;
        } else if (key === 'numero') {
          this.filtro.numero = null;
        } else if (key === 'assunto') {
          this.filtro.assunto = null;
        } else if (key === 'periodo_ato') {
          this.filtro.periodo_inicial_ato = null;
          this.filtro.periodo_final_ato = null;
        } else if (key === 'periodo_diario') {
          this.filtro.periodo_inicial_diario = null;
          this.filtro.periodo_final_diario = null;
        } else if (key === 'periodo_inicial_ato') {
          this.filtro.periodo_inicial_ato = null;
        } else if (key === 'periodo_final_ato') {
          this.filtro.periodo_final_ato = null;
        } else if (key === 'periodo_inicial_diario') {
          this.filtro.periodo_inicial_diario = null;
        } else if (key === 'periodo_final_diario') {
          this.filtro.periodo_final_diario = null;
        }
        const mockEvent = { preventDefault: () => {} };
        this.buscar(mockEvent);
      },
      atualizarOrdenacao(novoValor) {
        this.ordenarPor = novoValor;
      },
      abrirDadosAbertos: function (format) {
        if (
          this.totalResultados == undefined ||
          this.totalResultados == null ||
          this.totalResultados > 1000
        ) {
          alert(
            "O download dos dados é limitado a 1000 registros. Refaça sua consulta utilizando os filtros disponíveis."
          );
        } else {
          const params = new URLSearchParams({
            numero: this.getParam("numero") || "",
            tipo_ato: this.getParam("tipo_ato") || "",
            nome: this.getParam("nome") || "",
            ano: this.getParam("ano") || "",
            assunto: this.getParam("assunto") || "",
            periodo_inicial_ato: this.getParam("periodo_inicial_ato") || "",
            periodo_final_ato: this.getParam("periodo_final_ato") || "",
            periodo_inicial_diario: this.getParam("periodo_inicial_diario") || "",
            periodo_final_diario: this.getParam("periodo_final_diario") || "",
          }).toString();
          window.open(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${this.enteFederativo.id}/dados_abertos_atos_administrativos.${format}?${params}`,
            "_blank"
          );
        }
      },
    },
    computed: {
      cards() {
        return [
          {
            rota: { name: "AtosAdministrativosPorEnteFederativoPorTipo", params: { slug: this.slug } },
            icone: require("@/assets/images/icon-tipo-legislacao2.png"),
            iconeClasse: "legisla-icon",
            titulo: "Tipo de Ato",
            descricao: "Consulte os Atos Administrativos<br /> por <strong>tipo</strong>",
          },
          {
            rota: { name: "AtosAdministrativosPorEnteFederativoPorAno", params: { slug: this.slug } },
            icone: require("@/assets/images/icon-indice-cronologico2.png"),
            iconeClasse: "indice-icon",
            titulo: "Índice Cronológico",
            descricao: "Consulte os Atos Administrativos<br /> por <strong>ano</strong>",
          },
        ];
      },
      carregandoPagina: function () {
        return this.carregando || this.carregandoFiltros;
      },
      erroPagina: function () {
        return this.erroCarregandoFiltros || this.erro;
      },
      pageCount: function () {
        if (
          this.totalResultados != undefined &&
          this.totalResultados != null &&
          this.qtd_por_pagina != null &&
          this.qtd_por_pagina != undefined &&
          this.totalResultados > 0 &&
          this.qtd_por_pagina > 0
        ) {
          return Math.ceil(this.totalResultados / this.qtd_por_pagina);
        }
        return 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  h1 span{
    background-color: #ffb24e;
    color: #0e489f;
    border-radius: 12px;
    padding: 0 0.3rem;
    margin: 0; /* Remove a margem interna do h1 */
    display: inline;
    line-height: normal; /* Ajusta a altura da linha */
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
  }

  .titulo-pagina {
    display: flex;
    align-items: center; /* Alinha o triângulo e o texto verticalmente */
    gap: 1rem; /* Espaço entre o triângulo e o texto */
    // margin: 2rem 0rem 1.5rem 0; /* Mesmo espaçamento da legislação */
  }

  .triangulo-play {
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 25px solid #0e489f; /* mesma cor usada na outra view */
  }
  /* Alinha o título com os demais blocos em telas até 1023px */
  @media screen and (max-width: 1023px) {
    .titulo-pagina {
      margin-left: 1rem;
    }
  }
  /* remove bloco duplicado de h1 e usa o acima */
  .pesquise {
    background-color: #115810;
    padding: 0.5rem 1rem 5rem;
    label {
      color: white;
      font-size: 0.9rem;
    }
    input {
      width: calc(100% - 0.8rem);
      height: 2rem;
      border-radius: 0.2rem;
      border: none;
      padding-left: 0.5rem;
      font-family: "Poppins";
      font-size: 1rem;
      letter-spacing: 0.03rem;
    }
    .campo-preenchido {
      background-color: #fffed4;
      // border: solid .15rem #ffa900;
      // box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -moz-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -webkit-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
    }
    p {
      font-size: 0.9rem;
    }
    .botoes {
      float: right;
      margin: 1rem 0rem;
      button {
        margin-left: 1rem;
        padding: 0.1rem 2rem;
        font-size: 0.9rem;
        font-family: "Poppins-Medium";
      }
      button:first-child {
        background: transparent;
        border: white solid 0.15rem;
        color: white;
        padding: 0.1rem 2rem;
        cursor: pointer;
      }
      button:last-child {
        background-color: #ffa900;
        color: #2c3f2b;
        border: solid 0.15rem #ffa900;
        cursor: pointer;
      }
    }

    select {
      width: calc(100% - 0.2rem);
      height: 2rem;
      border: none;
      border-radius: 0.2rem;
      padding-left: 0.5rem;
      background-color: white;
      font-family: "Poppins";
      font-size: 1rem;
      letter-spacing: 0.03rem;
    }

    h2 {
      color: white;
      font-family: "Poppins-Bold";
      font-size: 1.1rem;
      display: inline-table;
      margin: 0rem;
      padding-right: 1rem;
      width: fit-content;
    }
    .row2 {
      display: grid;
      .row2mobile {
        display: grid;
        grid-template-columns: auto auto;
        gap: 1rem;
      }
    }
    .row5 {
      display: grid;
      margin-bottom: 0.5rem;
    }
    .grupo {
      border: #ffa900 solid 0.15rem;
      margin: 0.5rem 0rem;
      padding: 0.5rem 0.5rem;
      border-radius: 0.5rem;
      .data {
        display: grid;
        grid-template-columns: auto auto;
        gap: 1rem;
        .mx-datepicker {
          width: 100%;
        }
        .mx-input {
          height: 1rem !important;
        }
      }
      p {
        margin: 0rem;
        padding: 0rem;
        color: white;
      }
    }
    .item {
      display: grid;
      margin: 0.5rem 0rem;
    }
    .seta {
      img {
        width: 5rem;
        position: absolute;
        right: 1.2rem;
        margin-top: 3.5rem;
      }
      .t-preto {
        display: none;
      }
    }
  }
  .campo-resultados {
    margin: 1rem;
    h2 {
      color: #083e07;
      font-family: 'Anton', sans-serif;
      font-size: 1.1rem;
      margin: 1.5rem 0rem 0rem 1rem;
      display: table;
      padding-right: 1rem;
    }
  .dados-abertos {
    width: fit-content;
    margin: 1rem auto 0;
    padding: 0;
    p {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      margin: 0;
      background-color: #d3d4d3;
      padding: 0.2rem 0.75rem;
      font-size: 0.9rem;
      font-family: "Poppins", sans-serif;
      color: #083e07;
      border-radius: 0.2rem;
      line-height: 1.2;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
      span,
      a {
        margin: 0;
      }
    a {
      text-decoration: none;
      color: #083e07;
      font-family: "Poppins-Medium";
      cursor: pointer;
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
    .nav-resultados {
      // margin-bottom: 2rem;
      margin-left: 1rem;
      display: grid;

      .first-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;

        h2 {
          margin: 0;
        }

        .dados-abertos {
          padding-left: 0;
          margin: 0;
        }
      }

      .second-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.3rem 0;

        .ordenacao {
          margin: 0;
          display: flex;
          align-items: center;
        }
      }

      .third-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;

        .nresultados {
          margin: 0;
          width: fit-content;
          height: fit-content;

          p {
            display: block;
            width: fit-content;
            height: fit-content;
            font-size: 0.9rem;
            margin: 0rem;
            strong {
              font-family: "Poppins-Medium";
            }
          }
        }

        .npagina {
          margin: 0;

          label {
            font-family: "Poppins-Medium";
            font-weight: 900;
            margin-right: 0.5rem;
            color: #2c3f2b;
            font-size: 0.9rem;
          }
          select {
            border: none;
            background-color: #d3d4d3;
            font-size: 0.9rem;
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
  @media screen and (min-width: 31rem) {
    .nav-resultados {
      margin: 0 0.5rem 2rem 0.5rem;
      display: grid;

      .first-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0;

        h2 {
          margin: 0;
        }

        .dados-abertos {
          padding-left: 0;
          margin: 0;
        }
      }

      .second-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.3rem 1rem;

        .ordenacao {
          margin: 0;
          display: flex;
          align-items: center;
        }
      }

      .third-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.3rem 1rem;

        .nresultados {
          margin: 0;

          p {
            font-size: 0.9rem;
            margin: 0rem 0rem -2rem 1rem;
            strong {
              font-family: "Poppins-Medium";
            }
          }
        }

        .npagina {
          margin: 0;

          label {
            font-family: "Poppins-Medium";
            font-weight: 900;
            margin-right: 0.5rem;
            color: #2c3f2b;
            font-size: 0.9rem;
          }
          select {
            border: none;
            background-color: #d3d4d3;
            font-size: 0.9rem;
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
  @media screen and (min-width: 50rem) {
    .row5 {
      grid-template-columns: repeat(5, 1fr);
      gap: 1rem;
    }
  }
  @media screen and (min-width: 64rem) {
    h1 {
      margin-left: 0rem;
      font-size: 1.75rem;
    }
    h2 {
      font-size: 1.3rem !important;
    }
    .pesquise {
      padding-bottom: 5rem;
      h2 {
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
      .row2 {
        grid-template-columns: calc(50% - 1%) calc(50% - 1%);
        gap: 2%;
      }

      .grupo {
        padding: 0.5rem 2rem;
      }
      .botoes {
        margin-right: 0.2rem;
        margin-top: 1rem;
        button {
          font-size: 1rem;
          padding: 0.1rem 4rem !important;
          border-radius: 0.2rem;
        }
      }
      .seta {
        img {
          right: 5rem;
          margin-top: 3.5rem;
        }
      }
    }
    .campo-resultados {
    // background-color: #efeeed;
    
    h2 {
      font-family: 'Anton', sans-serif;
      font-size: 1.5rem;
      margin-left: 0rem;
      color: #083e07;
    }
    .dados-abertos {
      width: fit-content;
      margin: -2rem 1rem 0rem auto;
      p {
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 0 0.5rem;
        height: 1.2rem;
      }
      span,
      a {
        font-size: 0.8rem;
      }
    }
    .npagina {
      text-align: right;
      label {
        font-size: 0.8rem;
      }
    }
    .nresultados {
      max-width: 17rem;
      text-align: left;
      margin: 0rem 0rem 2rem;
      p {
        font-size: 0.8rem;
        margin: -1.5rem 0rem 0rem 0rem;
        text-align: left;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }
  }
  }

  .ordenacao {
    margin: 1rem 0;
    display: flex;
    align-items: center;
  }

  .ordenacao label {
    color: #2c3f2b;
    font-size: 0.9rem;
    font-family: "Poppins-Medium";
    margin-right: 0.5rem;
  }

  .ordenacao select {
    height: 1.5rem;
    border: none;
    border-radius: 0.2rem;
    padding: 0 0.5rem;
    background-color: #ffffff;
    font-family: "Poppins";
    font-size: 1rem;
    color: #2c3f2b;
    cursor: pointer;
    box-shadow: 0 0 0 0.15rem #ffa900;
    transition: background-color 0.3s, box-shadow 0.3s;
    appearance: none;
    background-image: url("data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMzZjJiIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI2Ij48cGF0aCBkPSJNNSA2IDAgMGgxMGwtNSA2eiIvPjwvc3ZnPg==");
    background-repeat: no-repeat;
    background-position: right 0.5rem center;
    background-size: 0.65rem;
    padding-right: 1.5rem;
  }

  .ordenacao select:hover {
    background-color: #edf2ee;
  }

  .ordenacao select:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem #ffa900;
  }

  @media screen and (max-width: 425px) {
    .ordenacao {
      flex-direction: column;
      align-items: flex-start;
    }
    .ordenacao label {
      margin-bottom: 0.8rem;
    }
    .ordenacao select {
      width: 100%;
    }
  }

  .pesquise .multiselect__content-wrapper {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    top: auto !important;
    max-height: 50vh !important;
    min-height: 100px;
    overflow-y: auto !important;
    z-index: 9999 !important;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }

  .multiselect__content {
    max-height: 50vh !important;
    height: auto !important;
    overflow-y: auto !important;
  }
  .mobile-dropdown-modal {
    position: fixed;
    left: 0; right: 0; bottom: 0; top: 0;
    background: rgba(0,0,0,0.10);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-dropdown-content {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
    width: 90vw;
    max-width: 320px;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
  }

  .mobile-dropdown-list {
    flex: 1;
    overflow-y: auto;
    list-style: none;
    margin: 0; padding: 0;
  }

  .mobile-dropdown-list li {
    display: flex;
    align-items: center;
    padding: 1.1rem 1rem;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 1.1rem;
    background: #fff;
    transition: background 0.2s;
  }

  .mobile-dropdown-list li.selected,
  .mobile-dropdown-list li:hover {
    background: #f5f5f5;
    color: #222;
  }

  .mobile-dropdown-list li input[type="checkbox"] {
    margin-right: 1rem;
    accent-color: #083e07;
    width: 1.2em;
    height: 1.2em;
  }

  .mobile-dropdown-apply {
    width: 100%;
    padding: 1.1rem 0;
    background: #083e07;
    color: #fff;
    border: none;
    font-size: 1.15rem;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0 0 16px 16px;
    transition: background 0.2s;
    margin: 0;
  }
  .mobile-dropdown-apply:active {
    background: #368f6e;
  }
  .chip-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 2px;
  }
  .chip {
    display: block;
    background: #e6f4f1;
    color: #2c3f2b;
    border-radius: 12px;
    padding: 6px 10px;
    font-size: 0.95em;
    border: 1px solid #083e07;
    white-space: normal;
    width: 100%;
    box-sizing: border-box;
  }
  .mobile-multiselect-trigger .chip-list {
    max-height: 80px;
    overflow-y: auto;
    margin-bottom: 2px;
  }
  .mobile-multiselect-trigger {
    overflow: hidden;
  }
  .row2mobile {
    align-items: start;
  }
  .chip-list-mobile {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 80px;
    margin-bottom: 2px;
    gap: 6px;
  }
  .chip-list-mobile .chip {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .tipo-nome-unico {
    display: block;
    width: 100%;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    font-weight: 600;
    color: #2c3f2b;
  }
  .pesquise .multiselect__content-wrapper {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    top: auto !important;
    max-height: 50vh !important;
    min-height: 100px;
    overflow-y: auto !important;
    z-index: 9999 !important;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }

  .multiselect__content {
    max-height: 50vh !important;
    height: auto !important;
    overflow-y: auto !important;
  }
  .mobile-dropdown-modal {
    position: fixed;
    left: 0; right: 0; bottom: 0; top: 0;
    background: rgba(0,0,0,0.2);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mobile-dropdown-content {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    width: 90vw;
    max-width: 400px;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .mobile-dropdown-header {
    padding: 1rem;
    border-bottom: 1px solid #eee;
    text-align: right;
    background: #f5f5f5;
  }
  .mobile-dropdown-header button {
    background: #ffa900;
    color: #2c3f2b;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    cursor: pointer;
  }
  .mobile-dropdown-list {
    flex: 1;
    overflow-y: auto;
    list-style: none;
    margin: 0; padding: 0;
  }
  .mobile-dropdown-list li {
    padding: 1rem;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 1.1rem;
    transition: background 0.2s;
  }
  .mobile-dropdown-list li.selected,
  .mobile-dropdown-list li:hover {
    background: #083e07;
    color: #fff;
  }
  .mobile-multiselect-trigger {
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    color: #333;
    font-size: 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 8px 0 8px;
    margin: 0;
    height: auto;
    min-height: 34px;
    width: 100%;
    box-sizing: border-box;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .mobile-multiselect-trigger:after {
    content: '\25BC';
    margin-left: auto;
    color: #aaa;
  }
  .mobile-dropdown-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: none;
    border-bottom: 1px solid #eee;
    font-size: 1.1rem;
    outline: none;
    box-sizing: border-box;
  }
  .mobile-dropdown-apply {
    width: 100%;
    padding: 1rem;
    background: #083e07;
    color: #fff;
    border: none;
    border-top: 1px solid #eee;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0 0 8px 8px;
    transition: background 0.2s;
  }
  .mobile-dropdown-apply:active {
    background: #368f6e;
  }
  .mobile-dropdown-list li input[type="checkbox"] {
    margin-right: 1rem;
    accent-color: #083e07;
  }
  .chip-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 2px;
  }
  .chip {
    display: block;
    background: #e6f4f1;
    color: #2c3f2b;
    border-radius: 12px;
    padding: 6px 10px;
    font-size: 0.95em;
    border: 1px solid #083e07;
    white-space: normal;
    width: 100%;
    box-sizing: border-box;
  }
  .mobile-multiselect-trigger .chip-list {
    max-height: 80px;
    overflow-y: auto;
    margin-bottom: 2px;
  }
  .mobile-multiselect-trigger {
    overflow: hidden;
  }
  .row2mobile {
    align-items: start;
  }
  .chip-list-mobile {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 80px;
    margin-bottom: 2px;
    gap: 6px;
  }
  .chip-list-mobile .chip {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .tipo-nome-unico {
    display: block;
    width: 100%;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    font-weight: 600;
    color: #2c3f2b;
  }
  .alto-contraste {
  .pesquise {
    background-color: #115810;
    .seta {
      .t-branco {
        display: none;
      }
      .t-preto {
        display: block;
      }
    }
    .botoes {
      button:last-child {
        background-color: #ffa900;
        color: #0d2b10;
        font-family: "Poppins-Medium";
      }
    }
  }
  .nav-resultados {
    h2 {
      color: white;
    }
  }
  .npagina {
    label {
      color: white !important;
    }
  }
  .nresultados {
    color: white;
    
    p {
      color: white !important;
      
      strong {
        color: white !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .dados-abertos p {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    min-width: fit-content;
    font-size: 0.7rem !important;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
}
</style>
